import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_99: FaireProductEntity = {
  token: "catalog_prod_prod-99",
  type: "product",
  name: "Serving Piece",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 62.42,
  msrpDollars: 156.05,
  sku: "CA0099",
  caseSize: 4,
  material: "Ceramic",
  collectionToken: "col_camp",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 327,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_home-accents"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
